import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import showMessage from '../atom/notification';
import { useSelector, useDispatch } from "react-redux";
import classes from './tripOverview/siginFeatures/profileInfo.module.scss';
import Helper from "../Helper";
import routes from "../routes.json";
import { useHistory } from "react-router";
import { LeftArrowSvg } from "../constants/resources";
import { Button } from "@mui/material";

const Quotes = (props: any) => {
    const { setProfile } = props;

    debugger;
    const { user, isAuthenticated, isLoading, loginWithRedirect, getIdTokenClaims } = useAuth0();
    const { isConnected } = useSelector((state: any) => state.Question);
    const [success, setSuccess] = useState(false);
    const history = useHistory();
    const [quotes, setQuotes] = useState<any[]>([]);

    useEffect(() => {
        if (!isAuthenticated) {
            loginWithRedirect({
                appState: {
                    returnTo: `${window.location.pathname}?id=${props.location?.state?.id}`,
                }
            });
        }
        else {
            // if (window.location.search.length > 0) {
            //     const idpair = window.location.search.split("=");

            //     history.replace(routes.PAYMENT, { id: idpair[1] });
            //     setSuccess(true);
            //     return;
            // }

            // if (!props.location?.state?.id) {
            //     setSuccess(true);
            //     return;
            // }

            if (isConnected && isConnected?.viatorApp === true) {
                newQuote();
            }
        }
    }, [isAuthenticated, isConnected, success]);

    const newQuote = () => {
        const res = Helper.sendToViatorPromise("expediaSearch", {
            forPublic: true,
            params: {
                activeNode: null,
                itinerary: null,
                data: {
                    rooms: [],
                    persons: [{
                        dateOfBirth: '2000-01-01'
                    }, {
                        dateOfBirth: '2000-01-01'
                    }]
                }
            },
            onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
                showMessage(title, message, type);
            },
            onSelect: (rooms: any) => {
                Helper.sendToViator({
                    route: ""
                });

                const newQuotes = [...quotes];
                const quote = rooms[0];

                newQuotes.push(quote);

                debugger;

                setQuotes(newQuotes);
            }
        }).catch(ex => {
            if (ex) {
                showMessage("Payment", "Quote application is not running", "danger");
            }
        });
    }

    const toArray = (obj: any): any => {
        return Object.values(obj);
    };

    return (
        <>
            <div className={classes.flex} onClick={() => setProfile('Main')}>
                <LeftArrowSvg />
                <div className={classes.backButton}>Back</div>
            </div>
            <div className={classes.refferalMain}>
                <Button size="small" onClick={() => newQuote()} variant="contained" className={classes.MarginRight8}>New Hotel Quote</Button>

                <div style={{padding: '10px'}}>
                { quotes.map((q: any, idx: number) => (
                    <div style={{padding: '10px'}} key={idx}>
                        <div>
                            Quote #{idx + 1}
                        </div>
                        <div>Propetry: <strong>{q.content.name}</strong></div>
                        <div>Address: {q.content.address.line_1} / {q.content.address.city} / {q.content.address.country_code}</div>
                        <div>
                            <div>Room: <strong>{ q.room?.room_name }</strong></div>
                            <div>Area: { q.contentRoom.area.square_feet } sq. ft.</div>
                            
                            { q.room?.rates.map((rate: any, ridx: number) => (
                                <div key={ridx} style={{paddingLeft: '10px'}}>
                                    {/* <div>Rate {ridx + 1}</div> */}
                                    <div><span>{rate.refundable ? "Refundable" : "Not refundable"}</span>,&nbsp;<span>Available rooms: {rate.available_rooms}</span></div>

                                    {toArray(rate.occupancy_pricing).map((pricing: any, pidx: number) => (
                                        <div key={pidx}>
                                            <div>
                                                { pricing.totals?.property_inclusive?.request_currency?.value && 
                                                    <div>Quote price:<strong>&nbsp;{pricing.totals?.property_inclusive?.request_currency?.value}</strong>&nbsp;{pricing.totals?.property_inclusive?.request_currency?.currency}</div>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div style={{paddingLeft: '10px'}}>
                            <h4>Price may vary, <strong>Call Travelsment agents to the actual quote</strong></h4>
                        </div>
                    </div>
                 ))}
                </div>
            </div>
        </>
    )

}

export default Quotes;